import type { PropsWithChildren } from 'react';

import { CardItemContainer } from './styles';

export interface AdjustableCardItemProps
  extends PropsWithChildren<{
    height: number;
  }> {}

export const AdjustableCardItem = ({ children, height }: AdjustableCardItemProps) => (
  <CardItemContainer height={height}>{children}</CardItemContainer>
);
